<Title name="{$messages["settings"]}" settingsPage={true} />

<LazyPage {pageComponent} {params} />

<script>
  import Title from '../_components/Title.html'
  import LazyPage from '../_components/LazyPage.html'
  import pageComponent from '../_pages/settings/index.html'

  export default {
    components: {
      Title,
      LazyPage
    },
    data: () => ({
      pageComponent
    })
  }
</script>
